import { AccessStatus } from '../../../services/dtos/article/article.dto';
import { REQUEST_ACCESS_HEADER, SUBSCRIPTION_HEADER } from '../../LockedContent/LockedContent.constants';

export const getHeaderTitle = (accessStatus: AccessStatus): string => {
  if (accessStatus === AccessStatus.privateAccessRequired) {
    return REQUEST_ACCESS_HEADER;
  }
  return SUBSCRIPTION_HEADER;
};
